/*
 * account 도메인
 */
export const ACCOUNT = {
  // 관리자 리스트
  ADMIN_LIST: ['account', 'admin', 'list'],
  // 관리자 상세
  ADMIN_DETAIL: ['account', 'admin', 'detail'],
};

/*
 * product 도메인
 */
export const PRODUCT = {
  // [상품 리스트[ 상품 리스트 조회
  LIST: ['product', 'list'],
  // [상품 상세] 상품 상세 데이터 가져오기
  PRODUCT_DETAIL: ['product', 'detail'],
  // [상품 버전] 상품 버전 데이터 가져오기
  PRODUCT_VERSION: ['product', 'version'],
  // [상품 커스텀 필드 정의] 정의 목록 가져오기
  CUSTOM_FIELD_DEFINITIONS: ['product', 'customFields', 'definitions'],
  // [상품 커스텀 필드] 상품별 커스텀 필드 값 가져오기
  CUSTOM_FIELDS: ['product', 'customFields'],
};

export const BRAND = {
  LIST: ['brand', 'list'],
};

export const EVENT = {
  LIST: ['event', 'list'],
};

/**
 * category 도메인
 */
export const CATEGORY = {
  // [카테고리 생성 관리] 카테고리 리스트 불러오기
  LIST: ['category', 'list'],
  // [카테고리 생성 관리] 카테고리 엑셀 리스트 다운로드 요청하기
  LIST_EXCEL: ['category', 'list', 'excel'],
  // [카테고리 생성 관리] 상품 일괄 업로드 잡 상태 조회하기 (비동기 처리 폴링)
  // 'list' prefix 밖에 둔다 — 완료 시 invalidateQueries(CATEGORY.LIST)가 prefix 매칭으로
  // 이 폴링 쿼리까지 다시 fetch 하는 것을 막기 위함
  LIST_EXCEL_BULK_JOB: ['category', 'excel', 'bulk', 'job'],
  // [카테고리 생성 관리] 카테고리 상세 불러오기
  DETAIL: ['category', 'detail'],
  // [카테고리 생성 관리] 카테고리 수정 이력 불러오기
  HISTORY_LIST: ['category', 'history', 'list'],
  // [카테고리 생성 관리] 서브 카테고리 리스트 불러오기
  SUB_CATEGORY_LIST: ['category', 'subCategory', 'list'],
  // [카테고리 생성 관리] 카테고리 상품 리스트 불러오기
  PRODUCT_LIST: ['category', 'product', 'list'],
  // [카테고리 생성 관리] 카테고리 상품 리스트 엑셀 다운로드 요청하기
  PRODUCT_LIST_EXCEL: ['category', 'product', 'list', 'excel'],
  // [카테고리 전시 관리] 카테고리 리스트 트리 불러오기
  LIST_TREE: ['category', 'list', 'tree'],
  // [카테고리 배너 관리] 카테고리 배너 슬라이드 조회
  BANNER: ['category', 'banner'],
};

export const ORDER = {
  PURCHASE_CONFIRMS_CHECK: ['order', 'purchaseConfirms', 'check'],
};

export const EVENT_QUERY_KEYS = {
  // [기획전] 기획전 리스트 조회
  LIST: ['event', 'list'],
  DETAIL: ['event', 'detail'],
};

export const TAG = {
  // 태스 리스트 조회
  LIST: ['tag', 'list'],
  // 연관 태그 리스트 조회
  DETAIL: ['tag', 'relate'],
  // 연결할 태그 엑셀 업로드
  EXCEL_UPLOAD: ['tag', 'upload'],
  // 상품 태그 조회
  PRODUCT: ['tag', 'product'],
  //연관 태그 리스트 조회
  RELATED_TAG: (tagId) => ['tag', 'related', tagId],
};

export const REVIEW = {
  // 카테고리 별 후기 평가 항목 조회
  CATEGORY_CRITERIA: ['review', 'categories', 'criteria'],
  // [리뷰] 리뷰 상세 조회
  DETAIL: ['review', 'detail'],
  // [리뷰] 리뷰 수정하기
  UPDATE: ['review', 'update'],
  // [리뷰] 리뷰 목록 조회하기
  LIST: ['review', 'list'],
  // [리뷰] 리뷰 엑셀다운로드 이메일 요청하기
  EXCEL_DOWNLOAD: ['review', 'excelDownload'],
};

export const POINT = {
  // 포인트 로그 조회
  LOGS: ['point', 'logs'],
  // 포이늩 회수
  RETRIEVE: ['point', 'retrieve'],
};

export const WIDGET = {
  DETAIL: ['widget', 'detail'],
  PRODUCT_LIST: ['widget', 'product', 'list'],
  BRAND_LIST: ['widget', 'brand', 'list'],
  EVENT_LIST: ['widget', 'event', 'list'],
};

export const COUPON = {
  LIST: ['coupon', 'list'],
};

export const MULTI_CHANNEL = {
  LIST: ['multiChannel', 'list'],
};
